import { z } from 'zod/v4';

import { columns } from './columns';

export const siteSchema = z.object(columns);

export type Site = z.output<typeof siteSchema>;

export const availableSiteSchema = siteSchema.pick({
  uuid: true,
  name: true,
  code: true,
  erpDB: true,
});

export type AvailableSite = z.output<typeof availableSiteSchema>;
